import { getInfo } from '@/api/user'
import { login, logout, getBase } from '@/api/common'
import { setToken, removeToken } from '@/utils/token'

export async function storeLogin(data) {
  await login(data).then(response => {
    setToken(response.token)
  })
}

export async function storeLogout() {
  await logout().then(response => {
    removeToken()
    sessionStorage.removeItem('role')
  })
}

export async function stroeGetBase() {
  await getBase().then(response => {
    sessionStorage.setItem('base', JSON.stringify(response.data))
    const authMap = new Map()
    const authArray = []
    response.data && response.data.auth && response.data.auth.forEach(e => {
      const o = {}
      const code = '' + e.systemCode + e.subSystemCode + e.modelCode + e.pageCode
      const str = e.system + '/' + e.subSystem + '/' + e.model + '/' + e.page
      o.id = e.id
      o.code = code
      o.str = str
      e.code = code
      e.str = str
      authArray.push(o)
      authMap.set(code, e)
    })
    sessionStorage.setItem('authMap', JSON.stringify(Array.from(authMap.entries())))
    sessionStorage.setItem('authArray', JSON.stringify(authArray))
  })
}

export async function stroeGetInfo() {
  await getInfo().then(response => {
    sessionStorage.setItem('info', JSON.stringify(response.data))
  })
}
